<div *ngIf="pageinitialed" class="generalPage" aria-label="help-about the codification" role="main">
  <div class="pr-22 content-container pb-0 print-all-content">
    <h1 class="sub-heading margin-0 content-blue bold itcHeavyFont mb-2" role="heading">{{atc_heading}}</h1>
    <p class="answer font-16 content-blue width-100" [innerHTML]="atc_desc"></p>
    <span class="para">
    <span class="pdf-link mr_0_5rem" (click)="openLinkById($event, true)" [innerHTML]="atc_link"> </span>
    <img src="../../../assets/icons/PDF_icon.svg" alt="PDF" class="pdf-image h-20px">
    </span>
  </div>
</div>
